export default "__VITE_ASSET__DeXJ8zo8__"